import { ITeachingBubbleProps } from "azure-devops-ui/TeachingBubble";

export type TeachingBubblesChanged = (teachingBubbles: ITeachingBubbleProps[]) => void;
export type TeachingDone = (position: number) => void;

export class TeachingService {
    private teachingBubbles: {[id: number]: ITeachingBubbleProps} = {};
    private onBlubblesChangedSubscribers: TeachingBubblesChanged[] = [];
    private onTeachingDoneSubscribers: TeachingDone[] = []


    public registerBubble(teachingBubble: ITeachingBubbleProps, position: number) {
        if(!!this.teachingBubbles[position])
            throw `This teaching bubble position (${position}) is already taken`;

        this.teachingBubbles[position] = teachingBubble;
        this.subscribersChanged();
    }

    public unregisterBubble(position: number) {
        if(!this.teachingBubbles[position])
            console.warn(`The teaching bubble position ${position} was already empty`);
        
        delete this.teachingBubbles[position];
        this.subscribersChanged();
    }

    // Subscribe to events caused by adding or removing a bubble, or marking a bubble as done
    public subscribe(onChange: TeachingBubblesChanged, onDone: TeachingDone) {
        this.onBlubblesChangedSubscribers.push(onChange);
        this.onTeachingDoneSubscribers.push(onDone);
    }

    public unsubscribe(onChange: TeachingBubblesChanged, onDone: TeachingDone) {
        this.onBlubblesChangedSubscribers = this.onBlubblesChangedSubscribers.filter(s => s !== onChange);
        this.onTeachingDoneSubscribers = this.onTeachingDoneSubscribers.filter(s => s !== onDone);
    }

    public markAsDone(position: number) {
        this.onTeachingDoneSubscribers.slice(0).forEach(s => s(position));
    }

    private subscribersChanged() {
        const bubblePositions = Object.keys(this.teachingBubbles).sort();
        const bubbles = bubblePositions.map(p => this.teachingBubbles[p]).slice(0);
        this.onBlubblesChangedSubscribers.slice(0).forEach(s => s(bubbles));
        
        console.debug("bubbles", this.teachingBubbles);
    }
}